module.exports = __webpack_public_path__ + "static/IUNEW3-duoi-a3b431b334818d72014530c52d72572b.png";